import PropTypes from 'prop-types';
import React from 'react';

import { createBEM } from '../../../../lib/utils/css';
import RowItemText from '../RowItemText';

import './RowItemThirdText.scss';

const RowItemThirdText = React.memo(props => {
  const {
    thirdText,
    thirdTextUrl,
    thirdTextOnclick,
    qaThirdText,
    thirdTextModifier,
    rightColChild,
    qaRightColChild,
    isRowSmall,
    isRightColPersistent,
  } = props;

  if (thirdText) {
    const childProps = {
      className: 'RowItemCenterColumn__thirdText',
      text: thirdText,
      href: thirdTextUrl,
      onClick: thirdTextOnclick,
      contentModifer: thirdTextModifier,
      qaTag: qaThirdText,
    };

    return <RowItemText {...childProps} />;
  } else if (!isRowSmall && !isRightColPersistent) {
    const className = createBEM('RowItemCenterColumn__thirdText', {
      rightColDuplicate: true,
    });

    const childProps = {
      className,
      text: rightColChild,
      qaTag: qaRightColChild,
    };

    return <RowItemText {...childProps} />;
  }

  return null;
});

RowItemThirdText.propTypes = {
  thirdText: PropTypes.string,
  thirdTextUrl: PropTypes.string,
  thirdTextOnclick: PropTypes.func,
  thirdTextModifier: PropTypes.string,
  qaThirdText: PropTypes.string,
  rightColChild: PropTypes.node,
  qaRightColChild: PropTypes.string,
  isRowSmall: PropTypes.bool,
  isRightColPersistent: PropTypes.bool,
};

export default RowItemThirdText;
